import React from "react";
import { Tabs } from "../../BP2Components";
import TabPane from "../../BP2Components/Tabs/TabPane";
import IntlMessages from "../../../util/IntlMessages";
import QuestionnaireSettings from "./QuestionnaireSettings";

type QuestionnaireModalProps = {
   value: {
      formId?: string;
      [key: string]: unknown;
   };
};

const QuestionnaireModal: React.FC<QuestionnaireModalProps> = (props) => {
   return (
      <Tabs defaultActiveKey="1">
         <TabPane tab={<IntlMessages id="settings.widgetSettings" />} key="1">
            <QuestionnaireSettings {...props} />
         </TabPane>
      </Tabs>
   );
};

export default QuestionnaireModal;
